import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/twitter.svg'


const _hoisted_1 = {
  key: 0,
  class: "p-2"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "my-4 text-2xl font-bold" }, "Email Preferences", -1)
const _hoisted_3 = { class: "mt-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, "Send me emails for the following brands:", -1)
const _hoisted_5 = { class: "ml-4" }
const _hoisted_6 = { class: "mt-4 mb-8" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, "Send me an email when:", -1)
const _hoisted_8 = { class: "ml-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "my-8 text-2xl font-bold" }, "Linked Accounts", -1)
const _hoisted_10 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  class: "w-6 mr-2",
  src: _imports_0
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "my-8 text-2xl font-bold" }, "Change Password", -1)
const _hoisted_13 = { key: 1 }

import TextField from '@/components/Inputs/TextField.vue';
import Checkbox from '@/components/Inputs/Checkbox.vue';
import Button from '@/components/UI/Button.vue';
import { useBrandStore } from '@/store/brands';
import { useUserStore } from '@/store/users';
import { inject, onMounted, reactive, Ref, toRefs } from 'vue';
import { UpdatePassword } from '@/typings/user';
import { cloneDeep } from 'lodash';
import { AlertModal, PromptModal } from '@/typings/modal';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const userStore = useUserStore();
const user = cloneDeep(userStore.secureUser);
const { secureUser } = toRefs(userStore);

const brandStore = useBrandStore();
const { brands } = toRefs(brandStore);

const newPassword = reactive<UpdatePassword>({
  current: '',
  new: '',
  confirm: '',
  error: false,
});

const alertModal = inject('alertModal') as Ref<AlertModal>;
const promptModal = inject('promptModal') as Ref<PromptModal>;

async function onChangePassword() {
  const success = await userStore.changePassword(newPassword);
  newPassword.error = !success;
  if (success) {
    alertModal.value.show(
      'Password changed',
      'Your password has been updated!'
    );
  }
}

async function onPreferenceUpdate() {
  if (user) {
    const success = await userStore.updateEmailPreferences({
      Email: user.Email,
      TwitterHandle: user.TwitterHandle,
      EmailPreferences: user.EmailPreference,
    });
    if (success) {
      alertModal.value.show(
        'Scorecard Preferences saved',
        'Your scorecard notification preferences have been updated!'
      );
    }
  }
}

async function onLinkTwitter() {
  const url = await userStore.linkTwitterAccount();
  if (url) {
    window.location = url;
  }
}

async function onUnlinkTwitter() {
  const doUnlink = await promptModal.value.show(
    'Unlink Twitter from account',
    'You are about to unlink your Twitter account from your Prowess account. You will no longer be able to login using Twitter. Are you sure?'
  );
  if (doUnlink) {
    const success = await userStore.unlinkTwitterAccount();
    if (success) {
      alertModal.value.show(
        'Twitter Unlinked',
        'Your Twitter account has been removed from your Prowess account.'
      );
    }
  }
}

onMounted(() => {
  brandStore.getBrands();
});

return (_ctx: any,_cache: any) => {
  return (_unref(user))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(TextField, {
          modelValue: _unref(user).Email,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(user).Email) = $event)),
          title: "Email",
          placeholder: "Enter email"
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("ul", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(brands), (brand) => {
              return (_openBlock(), _createElementBlock("li", {
                key: brand.Name
              }, [
                _createVNode(Checkbox, {
                  title: brand.Name,
                  modelValue: _unref(user).EmailPreference.Brands[brand.Name],
                  "onUpdate:modelValue": ($event: any) => ((_unref(user).EmailPreference.Brands[brand.Name]) = $event)
                }, null, 8, ["title", "modelValue", "onUpdate:modelValue"])
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("ul", _hoisted_8, [
            _createElementVNode("li", null, [
              _createVNode(Checkbox, {
                title: "A scorecard is opened",
                modelValue: _unref(user).EmailPreference.ScorecardOpened,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(user).EmailPreference.ScorecardOpened) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("li", null, [
              _createVNode(Checkbox, {
                title: "A scorecard is locking soon",
                modelValue: _unref(user).EmailPreference.ScorecardLockingSoon,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(user).EmailPreference.ScorecardLockingSoon) = $event))
              }, null, 8, ["modelValue"])
            ])
          ])
        ]),
        _createVNode(Button, {
          label: "Update Email Preferences",
          onClick: onPreferenceUpdate
        }),
        _hoisted_9,
        (_unref(secureUser))
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(TextField, {
                title: "Twitter",
                modelValue: _unref(secureUser).TwitterHandle,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(secureUser).TwitterHandle) = $event)),
                disabled: "",
                class: "w-full"
              }, {
                "title-badge": _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              }, 8, ["modelValue"]),
              (!_unref(secureUser).TwitterHandle)
                ? (_openBlock(), _createBlock(Button, {
                    key: 0,
                    onClick: onLinkTwitter,
                    type: "other",
                    class: "w-20 bg-twitter hover:bg-blue-400",
                    label: "Link"
                  }))
                : (_openBlock(), _createBlock(Button, {
                    key: 1,
                    onClick: onUnlinkTwitter,
                    type: "other",
                    class: "w-20 bg-twitter hover:bg-blue-400",
                    label: "Unlink"
                  }))
            ]))
          : _createCommentVNode("", true),
        _hoisted_12,
        _createVNode(TextField, {
          title: "Current Password",
          mask: "",
          modelValue: _unref(newPassword).current,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(newPassword).current) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(TextField, {
          title: "New Password",
          mask: "",
          modelValue: _unref(newPassword).new,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(newPassword).new) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(TextField, {
          title: "Confirm Password",
          mask: "",
          modelValue: _unref(newPassword).confirm,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(newPassword).confirm) = $event))
        }, null, 8, ["modelValue"]),
        (_unref(newPassword).error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, " Current password is incorrect or new password is not at least 8 characters or doesn't match the confirmation password "))
          : _createCommentVNode("", true),
        _createVNode(Button, {
          label: "Save New Password",
          onClick: onChangePassword
        })
      ]))
    : _createCommentVNode("", true)
}
}

})